// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
/*#region Text*/
/*#endregion */
/*#region Elements*/
/**#region Event Container */
/*#endregion*/
/*#endregion */
/* #region Screen */
/* #endregion*/
.time-picker-panel {
  max-height: 324px;
  width: 332px;
  box-sizing: border-box;
}

.radio-btn-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
  min-height: 22px;
}
.radio-btn-container input[type=radio] {
  -webkit-appearance: none;
          appearance: none;
  width: 18px;
  height: 18px;
  margin: 0;
  flex: 0 0 18px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: transparent;
  display: grid;
  place-content: center;
  cursor: pointer;
}
.radio-btn-container input[type=radio]::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffffff;
  transform: scale(0);
}
.radio-btn-container input[type=radio]:checked {
  border-color: #52aaff;
  background: #52aaff;
}
.radio-btn-container input[type=radio]:checked::before {
  transform: scale(1);
}

.radio-label {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0;
  cursor: pointer;
  color: #9dbcda;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: normal;
}

.date-time-container {
  margin-bottom: 0.5rem;
  color: #9dbcda;
}

.field {
  display: inline-flex;
  flex-flow: column-reverse;
  margin-bottom: 1em;
  position: relative;
}

.field > label {
  letter-spacing: 0.05em;
  font-size: 14px;
  margin-bottom: -22px;
  margin-left: 15px;
  color: #7089a4;
  z-index: 100;
  pointer-events: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
